import { FC } from 'react';

import CustomLoading from 'modules/_shared/components/CustomLoading';

import EditTradingOfferOperationStatusModalBody from './components/EditTradingOfferOperationStatusModalBody';
import EditTradingOfferOperationStatusModalHeader from './components/EditTradingOfferOperationStatusModalHeader';
import EditTradingOfferOperationStatusModalFooter from './components/EditTradingOfferOperationStatusModalFooter';

import { useEditTradingOfferOperationStatusModal } from './context/EditTradingOfferOperationStatusModalContext';

const EditTradingOfferOperationStatusModal: FC = () => {
  const { data } = useEditTradingOfferOperationStatusModal();

  return (
    <>
      <EditTradingOfferOperationStatusModalHeader />
      <EditTradingOfferOperationStatusModalBody />
      <EditTradingOfferOperationStatusModalFooter />

      {data.isLoading && <CustomLoading />}
    </>
  );
};

export default EditTradingOfferOperationStatusModal;
